/* ============================================================
   S/LAB 特設ページ 共通スクリプト（3ページで1本）
   ------------------------------------------------------------
   外部ライブラリは使わない（jQuery等を持ち込まない）。
   機能ごとに独立させてあるので、後から足しても互いに干渉しない。
     initNav()      … 大メニューの開閉
     initNavClip()  … FVの上・フッターの上にメニューを出さない（切り取り）
     initCarousels()… FV／ギャラリーのカルーセル（設定は要素ごとに別）
     initReveal()   … 下からフェードの時間差表示
     initScrollSpy()… 現在地ハイライト（スクロール位置基準）
   ============================================================ */
(function () {
  'use strict';

  /* この行が「本体が実際に動いた」という印。
     ページの冒頭にもインラインで印（c_slab-js）を付けているが、あれは
     「JSが動く環境である」ことしか表さない。本体が届かなかった場合でも
     その印は付くので、JSが動かない環境向けの姿（本文を見せる・メニューを
     流し込みに戻す・右端の縦書きを画像の直後に置く）が効かなくなる。
     本文は「表示の合図が出るまで隠す」作りなので、そのままだと本文だけが
     消えたページになる。CSS側はこの印の有無で切り替える。
     インラインの印はそのまま残す ―― 本体が届くまでの一瞬のちらつきを
     抑える指定は、本体より先に効かせる必要があるため。 */
  document.documentElement.classList.add('c_slab-ready');
  /* 遅れて届いたときのために、時間切れの印が付いていれば外す。 */
  document.documentElement.classList.remove('c_slab-nojs');

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------- 1. 大メニュー */
  function initNav() {
    var nav = document.querySelector('.c_slab_nav');
    if (!nav) return;

    var toggle = nav.querySelector('.c_slab_nav__toggle');
    var label = toggle && toggle.querySelector('.c_slab__sr');

    /* 閉じるときは、展開していた子項目も畳んで初期状態に戻す。
       既定は「畳んだ状態」なので、開き直したら畳んだ状態で出るのが正しい
       （開いたままだと、畳む手段が無くなってしまう）。 */
    function closeNav() {
      nav.classList.remove('is-open');
      Array.prototype.forEach.call(
        nav.querySelectorAll('.c_slab_nav__item.is-open'), function (item) {
          item.classList.remove('is-open');
          var a = item.querySelector('.c_slab_nav__link');
          if (a) a.setAttribute('aria-expanded', 'false');
        });
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (label) label.textContent = 'メニューを開く';
      /* いま見ている場所の親項目だけは開いた状態に戻す（下の syncOpen） */
      syncOpen(lastCurrent, true);
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        if (nav.classList.contains('is-open')) { closeNav(); return; }
        nav.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        if (label) label.textContent = 'メニューを閉じる';
      });
    }

    /* カードの外（ぼかした背景）を押しても閉じる。 */
    document.addEventListener('click', function (e) {
      if (!nav.classList.contains('is-open')) return;
      /* ぼかした背景は nav の ::before なので、そこを押すと e.target は
         nav そのものになる（子孫ではない）。nav 自身が対象のときは「外側を
         押した」として扱う。 */
      if (nav.contains(e.target) && e.target !== nav) return;
      closeNav();
    });

    /* 子項目のある親（ABOUT S/LAB・ATHLETES）は「子を開く」と「そのページへ
       移動する」の2つの役目を持つ。捌き方は下の click ハンドラを参照。 */
    var parents = nav.querySelectorAll('.c_slab_nav__item--has-sub');

    /* 親項目を開いておく条件は、現在地ハイライト（赤）に揃える。
       「リンクの行き先が同じページか」で判定すると、TOPページは FV と ABOUT の
       2つの中身を持つため、FVを見ている時点で ABOUT S/LAB が開いてしまう
       （赤は TOP なのに開くのは ABOUT）。現在地に合わせれば、赤と開閉が
       食い違うことが原理的に起きない。
       親は「自分が現在地 or 配下の子が現在地」のときに開く。
       現在地が変わったときだけ動かす ―― 手で畳んだものをスクロールのたびに
       開き直さないため（force で明示的にやり直せる）。 */
    var lastCurrent = null;
    function syncOpen(key, force) {
      if (!force && key === lastCurrent) return;
      lastCurrent = key;
      Array.prototype.forEach.call(parents, function (item) {
        var a = item.querySelector('.c_slab_nav__link');
        if (!a) return;
        var own = a.getAttribute('data-c_slab-nav');
        var on = !!key && !!own && (key === own || key.indexOf(own + '-') === 0);
        item.classList.toggle('is-open', on);
        a.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    }

    Array.prototype.forEach.call(parents, function (item) {
      var link = item.querySelector('.c_slab_nav__link');
      if (!link) return;
      link.setAttribute('aria-expanded', 'false');
      link.addEventListener('click', function (e) {
        /* 親項目は2段階。畳んである間は「開くだけ」で移動せず、開いている
           状態でもう一度押すと移動する。PCとSPで同じ。
             SP … 移動するとメニューごと閉じるので、1回目で移動してしまうと
                  出てきた子項目を選べない。
             PC … メニューは出ずっぱりだが、行き先を確かめてから選べる。
                  畳む操作は無く、移動すれば現在地に合わせて開き直る
                  （syncOpen が現在地の親だけを開く）。 */
        if (!item.classList.contains('is-open')) {
          e.preventDefault();                // 1回目＝開くだけ。移動しない
          e.c_slabOpenedSub = true;          // 「リンクを押したら閉じる」を通さない
          item.classList.add('is-open');
          link.setAttribute('aria-expanded', 'true');
          return;
        }
        /* 2回目＝そのまま移動する。e.c_slabOpenedSub を立てないので、
           下の「リンクを押したらSPのメニューは閉じる」がそのまま働く。 */
      });
    });

    /* メニューの中のリンクを押したら、SPのメニューは閉じる */
    nav.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a') : null;
      if (!a || !nav.classList.contains('is-open')) return;
      if (e.c_slabOpenedSub) return;   // 今この押下は親の開閉＝閉じない
      closeNav();
    });

    /* Escで閉じる */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) closeNav();
    });

    /* 現在地ハイライト（4.）から呼ばれる。初回もそこから呼ばれるので、ここでは呼ばない。 */
    nav.c_slabOpenCurrent = syncOpen;
  }

  /* ---------------------------------------------------------- 2. カルーセル
     FV用・ギャラリー用で別々に調整できるよう、秒数は要素の data-* に置く。
       data-c_slab-interval … 1枚あたりの表示時間（ミリ秒）
       data-c_slab-duration … 切り替えにかける時間（ミリ秒）
     ------------------------------------------------------------ */
  function createCarousel(el) {
    var track = el.querySelector('[class$="__track"]');
    if (!track) return;
    var real = track.children.length;   /* 本物の枚数（クローンを足す前に数える） */
    if (real < 2) return;

    var interval = parseInt(el.getAttribute('data-c_slab-interval'), 10) || 3000;
    var duration = parseInt(el.getAttribute('data-c_slab-duration'), 10) || 400;
    var index = 0, timer = null;

    /* 最後の1枚から1枚目へ戻るときも「同じ向きに1枚ぶんスライド」させる。
       ------------------------------------------------------------------
       素直に index を 0 に戻すと、transform が -300% → 0% へ動くので、
       全枚数ぶんを一気に逆走してしまう。
       → 末尾に1枚目の複製を1枚足しておき、
         「最後 → 複製」までは普通に左へ流す（見た目は1枚目に着いたところ）。
         着いた直後、次に進める瞬間にアニメ無しで本物の1枚目へ位置だけ戻す。
         見えている絵は同じなので、継ぎ目は分からない。
       複製は読み上げ・タブ移動に二重に出ないよう aria-hidden にし、
       中のリンクは tabindex=-1、id は落とす（同じ id が2つできるのを防ぐ）。 */
    var clone = track.children[0].cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.removeAttribute('id');
    Array.prototype.forEach.call(clone.querySelectorAll('[id]'), function (n) {
      n.removeAttribute('id');
    });
    Array.prototype.forEach.call(clone.querySelectorAll('a'), function (a) {
      a.setAttribute('tabindex', '-1');
    });
    track.appendChild(clone);
    var slides = track.children;   /* = real + 1 枚 */

    track.style.transitionDuration = (REDUCED ? 0 : duration) + 'ms';

    /* 次に出る写真を先に読み込んでおく。
       ------------------------------------------------------------------
       スライドは横一列に並んでいて、表示中の1枚以外は画面の外にある。
       loading="lazy" は画面に入りそうになって初めて読み込みを始めるので、
       そのままだと切り替わる瞬間に読み込みが始まり、スライドインしてくる
       写真が白いまま出てしまう。
       → 表示中の1枚に加えて次の2枚を eager に変え、読み込みを前倒しする。
         2枚ぶん先まで見ておけば、切り替え間隔ぶんの猶予ができる。
       画面外の残りは lazy のままなので、最初にまとめて読み込む形にはならない。 */
    function preload(i) {
      for (var k = 1; k <= 2; k++) {
        var s = slides[(i + k) % slides.length];
        if (!s) continue;
        Array.prototype.forEach.call(s.querySelectorAll('img[loading="lazy"]'), function (img) {
          img.setAttribute('loading', 'eager');
        });
      }
    }

    function place(i) {
      index = i;
      track.style.transform = 'translateX(' + (-100 * i) + '%)';
      Array.prototype.forEach.call(slides, function (s, n) {
        s.classList.toggle('is-active', n === i);
      });
      preload(i);
    }
    function show(i) {
      track.style.transitionDuration = (REDUCED ? 0 : duration) + 'ms';
      place(i);
    }
    function next() {
      if (index >= real) {
        /* いま複製の上にいる＝見た目は1枚目。アニメ無しで本物の1枚目へ座り直す。
           ここで一度レイアウトを確定させないと、ブラウザが2つの変更をまとめてしまい
           「戻る動き」が見えてしまう（offsetWidth の参照がその区切りになる）。 */
        track.style.transitionDuration = '0ms';
        place(0);
        void track.offsetWidth;
      }
      show(index + 1);
    }
    function start() {
      if (timer) return;
      timer = window.setInterval(next, interval);
    }
    function stop() { window.clearInterval(timer); timer = null; }

    /* ホバーで停止。
       「視差効果を減らす」設定でも自動再生そのものは止めない。手動の送りボタンが
       無いので、止めると1枚目しか見られなくなるため。動きの長さだけ 0 にする
       （下の transitionDuration と CSS 側の @media）。 */
    el.addEventListener('mouseenter', stop);
    el.addEventListener('mouseleave', start);
    el.addEventListener('focusin', stop);
    el.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });

    show(0);
    start();
  }

  function initCarousels() {
    var list = document.querySelectorAll('[data-c_slab-carousel]');
    Array.prototype.forEach.call(list, createCarousel);
  }

  /* ---------------------------------------------------------- 3. 下からフェード
     同時に画面へ入ってきたものは、上から順に時間差で出す
     （写真 → 見出し → 本文1 → 本文2 …）。 */
  function initReveal() {
    var items = document.querySelectorAll('.c_slab-reveal');
    if (!items.length) return;

    function showAll() {
      Array.prototype.forEach.call(items, function (el) { el.classList.add('is-visible'); });
    }
    if (!('IntersectionObserver' in window)) { showAll(); return; }

    var STEP = 150; /* 表示をずらす間隔（ミリ秒） */
    var io = new IntersectionObserver(function (entries) {
      var arrived = entries.filter(function (en) { return en.isIntersecting; });
      arrived.sort(function (a, b) {
        return a.boundingClientRect.top - b.boundingClientRect.top;
      });
      arrived.forEach(function (en, i) {
        en.target.style.transitionDelay = (REDUCED ? 0 : i * STEP) + 'ms';
        en.target.classList.add('is-visible');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -15% 0px', threshold: 0.2 });   /* 出始める位置 */

    Array.prototype.forEach.call(items, function (el) { io.observe(el); });
  }

  /* ---------------------------------------------------------- 4. 現在地ハイライト
     ページ単位ではなくスクロール位置に合わせる（1ページの中を移動しても
     メニューと中身がずれないようにするため）。 */
  function initScrollSpy() {
    var links = document.querySelectorAll('[data-c_slab-nav]');
    if (!links.length) return;

    var targets = [];
    Array.prototype.forEach.call(links, function (a) {
      var key = a.getAttribute('data-c_slab-nav');
      var href = a.getAttribute('href') || '';
      var hash = href.indexOf('#') >= 0 ? href.slice(href.indexOf('#') + 1) : '';
      /* 現在地の判定に使う位置だけを差し替えられるようにする。
         ABOUT S/LAB には ATHLETES のような専用のリード文が無く、扉の写真のすぐ後が
         「スピリット」なので、扉に着いた時点で両方が赤くなるようにしたい。
         リンクの飛び先（href）は見出しのままにしておきたいので、
         判定に使う要素だけを data-c_slab-spy で指定する。 */
      var spyId = a.getAttribute('data-c_slab-spy') || hash;
      var el = spyId ? document.getElementById(spyId) : null;
      /* このページの中にある見出しだけを見る（他ページへのリンクは対象外）。
         「href が # で始まるか」で判定してはいけない ―― リンクは
         /pages/slab_athlete_story#c_slab-about のようにページのURL付きで
         出力されるので、その条件では1件も拾えず、現在地ハイライトが丸ごと
         動かなくなる。要素がこのページに在るか（getElementById）だけで足りる。 */
      if (el) targets.push({ key: key, el: el });
    });
    if (!targets.length) return;

    function update() {
      var line = window.scrollY + window.innerHeight * 0.3;
      var current = null;
      targets.forEach(function (t) {
        if (t.el.getBoundingClientRect().top + window.scrollY <= line) current = t.key;
      });
      /* 赤は「今いる階層」＝親と子の両方。ATHLETESページなら、リード文の間は
         ATHLETES だけ赤、記事に入ったら ATHLETES と人名の両方が赤になる。 */
      Array.prototype.forEach.call(links, function (a) {
        var key = a.getAttribute('data-c_slab-nav');
        var on = !!current && (key === current || current.indexOf(key + '-') === 0);
        a.classList.toggle('is-current', on);
      });
      /* 親の開閉は現在地に合わせる（1. の syncOpen）。 */
      var nav = document.querySelector('.c_slab_nav');
      if (nav && nav.c_slabOpenCurrent) nav.c_slabOpenCurrent(current);
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { update(); ticking = false; });
    }, { passive: true });
    window.addEventListener('resize', update);
    /* 最初の1回だけでは足りない。回線が遅いと、CSSや画像が届く前に測ることに
       なり、見出しの位置がまだ全部ページの先頭あたりに固まっている。すると
       ページの最上部なのに最後の見出しが「現在地」になり、スクロールするまで
       赤が動かない。中身が確定した後（読み込み完了・書体の差し替え・裏のタブが
       表に出たとき）にもう一度測る。 */
    window.addEventListener('load', update);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(update).catch(function () {});
    }
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) update();
    });
    update();
  }

  /* ---------------------------------------------------------- 5. FVの上・フッターの上にメニューを出さない
     PCでは、FVを見ている間メニューが出ない（FVがメニューより上のレイヤー）。
     FVがあるのはTOPページだけなので、他の2ページでは何もしない（＝常に出たまま）。
     SPは逆でFVの上にもハンバーガーが出るため、CSS側はPCの @media の中だけ。
     重なり順では実現できない理由は c_slab.css の同じ箇所に書いてある。

     FVの下端の位置を毎回渡して切り取り位置にする＝FVが上へ流れるにつれて
     メニューが下から少しずつ出てくる。「丸ごと出す／隠す」にすると、
     リード文のあたりでメニューが突然現れてしまう。 */
  function initNavClip() {
    var nav = document.querySelector('.c_slab_nav');
    if (!nav) return;
    var list = nav.querySelector('.c_slab_nav__list');
    var fv = document.querySelector('.c_slab_fv');

    /* SP右端の縦書きのページ名。
       入れ物（<p>・高さ0）は画像の直後の流し込みに残して「出発点の目印」にし、
       文字だけを画面に固定する。
       文字は .c_slab__grid の外へ出す必要がある ―― グリッドには入場アニメの
       transform が常に効いていて、その中の position: fixed は「画面」ではなく
       「グリッド」を基準に置かれるため、貼りつかずに一緒に流れてしまう。
       メニューが同じ作りで正しく動くのは、グリッドの外にあるため。 */
    var titles = [];
    Array.prototype.forEach.call(document.querySelectorAll('.c_slab__pagetitle'), function (p) {
      var text = p.querySelector('.c_slab__pagetitle-text');
      if (!text) return;
      nav.parentNode.appendChild(text);
      titles.push({ anchor: p, text: text });
    });

    /* 「フッター」の始まりは、テーマ側が出す3つのかたまりのうち一番上。
         ・.support-banner            … お問い合わせ／送料無料／返品について のアイコン帯
         ・.c-splus-footer__container … S/PLUS（メンバーシップ）の紹介ブロック
         ・footer                     … 配送国・SNS・リンク一覧
       デザイン上フッターとして扱われているのはこの3つを合わせた範囲なので、
       「フッターの下に潜る」の境界はアイコン帯の上端になる。
       テーマ側の要素なので、無い場合も動くようにする。 */
    var edges = ['.support-banner', '.c-splus-footer__container', 'footer'];
    function footerTop() {
      var top = null;
      for (var i = 0; i < edges.length; i++) {
        var el = document.querySelector(edges[i]);
        if (!el) continue;
        var t = el.getBoundingClientRect().top;
        if (top === null || t < top) top = t;
      }
      return top;
    }

    /* 上（FVの下端）と下（フッターの上端）の両方を1つの inset() にまとめる。
       2つに分けると後から書いたほうが前を打ち消してしまう。 */
    function clip(el, withFv, fTop) {
      var r = el.getBoundingClientRect();
      var top = 0, bottom = 0;
      if (withFv && fv) top = Math.max(0, fv.getBoundingClientRect().bottom - r.top);
      if (fTop !== null) bottom = Math.max(0, r.bottom - fTop);
      return (top || bottom) ? 'inset(' + top + 'px 0 ' + bottom + 'px 0)' : 'none';
    }

    function update() {
      var fTop = footerTop();
      /* PCの左メニュー。FVがあるのはTOPページだけなので、他では上の切り取りは0になる。 */
      if (list) nav.style.setProperty('--c_slab-nav-clip', clip(list, true, fTop));
      /* SP右端の縦書きのページ名。
         入れ物（高さ0・画像の直後）の位置＋20px から出発し、72px で止まる。
         そのままフッターの上端まで貼りついて、そこから下へ潜る。 */
      titles.forEach(function (t) {
        var top = Math.max(72, t.anchor.getBoundingClientRect().top + 20);
        t.text.style.setProperty('--c_slab-pt-top', top + 'px');
        var bottom = fTop === null ? 0
          : Math.max(0, top + t.text.getBoundingClientRect().height - fTop);
        t.text.style.setProperty('--c_slab-pt-clip',
          bottom ? 'inset(0 0 ' + bottom + 'px 0)' : 'none');
      });
    }

    /* ここは requestAnimationFrame を挟まず、その場で判定する。
       やることが「数値の比較」と「変数の書き換え」だけで軽いため。 */
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    /* 測り直しの機会を増やす。
       最初の1回だけでは足りない ―― 回線が遅いと、CSSや画像が届く前に測って
       しまう。そのとき中身の高さはまだ確定していないので、出発点が
       ページの最上部あたりに来て、そのまま居座る（scroll か resize が
       起きるまで測り直されないため）。
         ・load          … CSS・画像・フォントがすべて届いた後の確定値
         ・fonts.ready   … 欧文フォントの差し替えで文字の高さが変わる
         ・ResizeObserver… 遅れて届いた画像などで中身の高さが変わったとき
       いずれも同じ update を呼ぶだけなので、重複して走っても害はない。 */
    window.addEventListener('load', update);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(update).catch(function () {});
    }
    if (window.ResizeObserver) {
      var target = nav.parentNode;
      if (target) new ResizeObserver(update).observe(target);
    }
    /* 裏のタブで読み込まれた場合。表に出るまで並べ直しが後回しにされるので、
       読み込みが終わった時点でもまだ高さが確定していないことがある。
       表に出た瞬間にもう一度測る。 */
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) update();
    });
    update();
  }

  /* ---------------------------------------------------------- 6. 画面幅を変えている間は動きを止める
     980pxの境目をまたぐ瞬間、PC用とSP用でメニューの見せ方が入れ替わる。
     そのとき opacity などの transition が走ってメニューが一瞬ちらつくので、
     幅を変えている間だけ動きを切り、手が止まって 200ms 経ったら元に戻す。 */
  function initResizeGuard() {
    var root = document.documentElement, timer = null;
    window.addEventListener('resize', function () {
      root.classList.add('c_slab-resizing');
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () { root.classList.remove('c_slab-resizing'); }, 200);
    });
  }

  function init() {
    initNav();
    initNavClip();
    initResizeGuard();
    initCarousels();
    initReveal();
    initScrollSpy();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
